import { create } from "zustand";
import { SowContext, SowState } from "./sowContext.types";
import { fetchActivityItemDetails } from "services/input-core/activity-items/get-activity-item-by-code";

export const INITIAL_SOW_STATE: SowState = {
  sows: [],
  sowProfile: null,
  activityItemSelected: null,
  activityFlow: null,
  activityItemDetails: null,
  isEnabled: false,
};

export const useSowContext = create<SowContext>((commit) => ({
  ...INITIAL_SOW_STATE,

  getSows(sows) {
    commit((state) => ({
      ...state,
      sows,
    }));
  },

  getSowProfile(sowProfile) {
    commit((state) => ({
      ...state,
      sowProfile,
    }));
  },
  enableActivityItemProfile(isEnabled) {
    commit((state) => ({
      ...state,
      isEnabled,
    }));
  },

  getActivitySelected(activity) {
    commit((state) => ({
      ...state,
      activityItemSelected: activity,
    }));
  },

  async getActivityDetails(activity) {
    const response = await fetchActivityItemDetails({
      zIdentifier: activity.zIdentifier,
      fieldglassId: activity.fieldglassId,
    });

    commit((state) => ({
      ...state,
      activityItemDetails: response,
    }));
  },

  getActivityFlow(activityFlow) {
    commit((state) => ({
      ...state,
      activityFlow,
    }));
  },

  clearDetails() {
    commit((state) => ({
      ...state,
      activityItemSelected: null,
      activityItemDetails: null,
    }));
  },
}));
